module.exports = __webpack_public_path__ + "img/public/SiteIcons/editStepTwo.svg?7d96b767";